import React, { useState, useEffect } from "react";
import {
    withStyles,
    makeStyles,
    createStyles,
    useTheme,
} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Chip from '@mui/material/Chip';
import { Box } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import FilterComponents from "../FilterComponents/FilterComponents";
import filterObj from "./FilterInstantiation"
import { chartObj } from './ChartConstants';
import { getCookie } from "../../services/Cookies";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import TrendsList from "../trends/TrendsList";
import Charts from '../trends/Charts';
import { getRequest, postRequest } from "../../services/ApiServices";
import { getCurrentDate, getCurrentDateOfBelow, getDefaultFuelDate, getDefaultLubeDate, getDefaultTrendsDate, getDefaultTotDate } from "../../services/DateServices";
import moment from 'moment';
import TrendsHelp from "../trends/TrendsHelp";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: "flex",
        padding: "0px",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    gridSpacing: {
        margin: "0 !important",
        width: "100% !important",
    },
}));

export default function Trends(props) {
    const [transformerList, setTransformerList] = useState([]);
    const [formObj, setFormObj] = React.useState(filterObj);
    const [selectedTransformerList, setSelectedTransformerList] = useState([]);
    const dispatch = useDispatch();
    const classes = useStyles();


    const applyFilter = (obj) => {
      setSelectedTransformerList([]);
        getFilterTranformerListData(obj);
    }

    const onClear = () => {
        setTransformerList([]);
        setSelectedTransformerList([]);
    };

    useEffect(() => {
        debugger
        //getShipListData(getCookie("clientId"));

        let getCookieval = localStorage.getItem('GlobalFilterSetting');
        if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
            let Obj = JSON.parse(getCookieval);
            let JSONFormat = Obj
            JSONFormat = {
                ...Obj,
            }
            let totsamplestartdate = (Obj.Totsamplestartdate && Obj.Totsamplestartdate[0] ? Obj.Totsamplestartdate[0] : Obj.Totsamplestartdate);
            let totsampleenddate = (Obj.Totsampleenddate && Obj.Totsampleenddate[0] ? Obj.Totsampleenddate[0] : Obj.Totsampleenddate)
            if (totsamplestartdate && totsampleenddate && totsamplestartdate != null && totsampleenddate != null) {
                JSONFormat.sampleDate = {
                    startDate: moment(totsamplestartdate).format('YYYY/MM/DD'),
                    endDate: moment(totsampleenddate).format('YYYY/MM/DD')
                }
            } else {
                let dt = getDefaultTrendsDate();
                JSONFormat.sampleDate = {
                    startDate: moment(dt.startDate).format('YYYY/MM/DD'),
                    endDate: moment(dt.endDate).format('YYYY/MM/DD')
                };
                JSONFormat.HistoricVessel = false
            }
            //getFilterTranformerListData(JSONFormat);

        } else {
            //getFilterTranformerListData();
        }
    }, []);

    const getFilterTranformerListData = (formObj) => {  

        let filterObj = {};
        let Data = {};
        if (formObj !== "" && formObj !== undefined) {
            if (formObj.HistoricVessel == true) {
                filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
            } else {
                filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
            }
            if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
            if (formObj.TotTransformerName && formObj.TotTransformerName.length > 0) { filterObj = { ...filterObj, TotTransformerName: formObj.TotTransformerName } }
            if (formObj.Totlocation && formObj.Totlocation.length > 0) { filterObj = { ...filterObj, Totlocation: formObj.Totlocation } }
            if (formObj.Totvoltage && formObj.Totvoltage.length > 0) { filterObj = { ...filterObj, Totvoltage: formObj.Totvoltage } }
            if (formObj.Totmanufacture && formObj.Totmanufacture.length > 0) { filterObj = { ...filterObj, Totmanufacture: formObj.Totmanufacture } }
            if (formObj.TotRating && formObj.TotRating.length > 0) { filterObj = { ...filterObj, TotRating: formObj.TotRating } }
            if (formObj.TotSubCustomerName && formObj.TotSubCustomerName.length > 0) { filterObj = { ...filterObj, TotSubCustomerName: formObj.TotSubCustomerName } }
            if (formObj.TotUnitDescription && formObj.TotUnitDescription.length > 0) { filterObj = { ...filterObj, TotUnitDescription: formObj.TotUnitDescription } }
            if (formObj.Totserialnumber && formObj.Totserialnumber.length > 0) { filterObj = { ...filterObj, Totserialnumber: formObj.Totserialnumber } }
            if (formObj.sampleDate) { filterObj = { ...filterObj, sampleDate: formObj.sampleDate } }


            if (formObj.sampleDate) {
                const myJSONData = JSON.stringify(filterObj);
                Data = {
                    Data: myJSONData,
                }
            } else {
                let JSONFormat = filterObj;
                JSONFormat = { ...filterObj }
                if (formObj?.Totsamplestartdate != null && formObj?.Totsampleenddate != null) {
                    let sampleStartDate = (formObj.Totsamplestartdate[0].startDate ? formObj.Totsamplestartdate[0].startDate : formObj.Totsamplestartdate[0]);
                    let sampleEndDate = (formObj.Totsampleenddate[0].endDate ? formObj.Totsampleenddate[0].endDate : formObj.Totsampleenddate[0])
                    if (sampleStartDate && sampleEndDate && sampleStartDate != null && sampleEndDate != null) {
                        JSONFormat.sampleDate = {
                            startDate: moment(sampleStartDate).format('YYYY/MM/DD'),
                            endDate: moment(sampleEndDate).format('YYYY/MM/DD')
                        }
                    }
                }
                const myJSONData = JSON.stringify(JSONFormat);
                Data = {
                    Data: myJSONData,
                }
            }
        }
        dispatch({ type: LOADING, payload: true });
        // const myJSONData = JSON.stringify(JSONFormat);
        // const Data = {
        //   Data: myJSONData,
        // }
        const url =
            process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
            `Trend/TransformersList/Filter`;
        postRequest(url, Data)
            .then((res) => {
                console.log("res", res);
                if (res.status == 200) {
                    dispatch({ type: LOADING, payload: false });
                    setTransformerList(res.data);
                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                dispatch({ type: LOADING, payload: false });
            });
    };

    const setTransformerSelectedId = (row) => {
        setSelectedTransformerList([...row]);
    };

    const removeTransformerList = (item) => {
        let indexofKey = selectedTransformerList.indexOf(item);
        selectedTransformerList.splice(indexofKey, 1)
        setSelectedTransformerList([...selectedTransformerList]);
    }

    return (
        <Box component="div" px={2} className={classes.root}>
            <Grid container spacing={3} className={classes.gridSpacing}>
                <TrendsHelp/>

                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Box className="decarbox1" component="div" style={{ padding: "20px" }}  >
                            <FilterComponents screen={"trendsToT"} defaultDate={getDefaultTrendsDate()} filtervalue={["CustomerName", "TransformerName", "TotSubCustomer_NameComponent", "SerialNumber", "Location", "Manufacturer", "Voltage", "Rating", "TotSampleDateComponent", "TotUnitDescripitionComponent"]} applyFilter={applyFilter} reset={onClear} />
                        </Box>
                        <Grid className="ast-grid" item xs={12} sm={6} md={5}>
                            <Box component="h2" m={0} textAlign="left" className="blcopy" fontWeight="500" style={{ marginRight: "-1em" }}>
                                Selected Assets:
                            </Box>
                        </Grid>
                        <div width="100%">
                            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }}>
                                {selectedTransformerList.length ? selectedTransformerList.map((item) => {
                                    debugger

                                    return (
                                        <Chip
                                            label={item.tranformerName}
                                            onDelete={() => { removeTransformerList(item) }}
                                            sx={{ margin: "3px", fontSize: "12px" }}
                                        />

                                    )
                                }) : null}
                            </Box>
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={3} md={2}>
                    <TrendsList transformerList={transformerList} selectedTransformerList={selectedTransformerList} setTransformerSelectedId={setTransformerSelectedId} />
                </Grid>
                <Grid item xs={9} md={10}>
                    <Grid container spacing={3} >
                        {chartObj.map((item) => {
                            return (
                                <Charts chartParameters={item} selectedTransformerList={selectedTransformerList} formObj={formObj} />
                            )
                        })}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}